export const SET_MESSAGE_DIALOG = 'SET_MESSAGE_DIALOG';
